__turbopack_context__.v({
  "body": "AddToCartSlider-module-scss-module__gjY1_q__body",
  "footer": "AddToCartSlider-module-scss-module__gjY1_q__footer",
  "primaryButton": "AddToCartSlider-module-scss-module__gjY1_q__primaryButton",
  "secondaryButton": "AddToCartSlider-module-scss-module__gjY1_q__secondaryButton",
  "sheet": "AddToCartSlider-module-scss-module__gjY1_q__sheet",
  "shell": "AddToCartSlider-module-scss-module__gjY1_q__shell",
});
